import type { Account } from '../types/Account';

export function filterAccounts(accounts: Account[], searchTerm: string): Account[] {
  const trimmed = searchTerm.trim();
  if (!trimmed) return [...accounts];
  const lower = trimmed.toLowerCase();
  return accounts.filter((account) =>
    account.name.toLowerCase().includes(lower)
  );
}
